import { reactive, computed, watch } from 'vue';

export default function Driver(data = {}) {

    const state = reactive({
        id: data.id || '',
        lastName: data.lastName || '',
        firstName: data.firstName || '',
        email: data.email || '',
        phoneNumber: data.phoneNumber || '',
        address: data.address || '',
        city: data.city || '',
        state: data.state || '',
        zipCode: data.zipCode || '',
        country: data.country || '',
    });

    // Computed properties for validations
    const validations = {
        isLastNameValid: computed(() => !!state.lastName.trim()),
        isFirstNameValid: computed(() => !!state.firstName.trim()),
        isEmailValid: computed(() => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)),
        isPhoneNumberValid: computed(() => /^\+?[0-9]{10,15}$/.test(state.phoneNumber)),
    };

    // Individual field validation functions
    const validateLastName = () => {
        if (validations.isLastNameValid.value) {
            $('#driver-last-name-input').removeClass('is-invalid');
            $('#driver-last-name-error').addClass('d-none');
            return true;
        } else {
            $('#driver-last-name-input').addClass('is-invalid');
            $('#driver-last-name-error').removeClass('d-none');
            return false;
        }
    };

    const validateFirstName = () => {
        if (validations.isFirstNameValid.value) {
            $('#driver-first-name-input').removeClass('is-invalid');
            $('#driver-first-name-error').addClass('d-none');
            return true;
        } else {
            $('#driver-first-name-input').addClass('is-invalid');
            $('#driver-first-name-error').removeClass('d-none');
            return false;
        }
    };

    const validateEmail = () => {
        if (validations.isEmailValid.value) {
            $('#driver-email-input').removeClass('is-invalid');
            $('#driver-email-error').addClass('d-none');
            return true;
        } else {
            $('#driver-email-input').addClass('is-invalid');
            $('#driver-email-error').removeClass('d-none');
            return false;
        }
    };

    const validatePhoneNumber = () => {
        if (validations.isPhoneNumberValid.value) {
            $('#driver-phone-number-input').removeClass('is-invalid');
            $('#driver-phone-number-error').addClass('d-none');
            return true;
        } else {
            $('#driver-phone-number-input').addClass('is-invalid');
            $('#driver-phone-number-error').removeClass('d-none');
            return false;
        }
    };


    // Set up watchers for real-time validation
    watch(() => state.lastName, validateLastName);
    watch(() => state.firstName, validateFirstName);
    watch(() => state.email, validateEmail);
    watch(() => state.phoneNumber, validatePhoneNumber);

    // Validation logic for the entire form
    const isValid = () => {
        let isLastNameValid = validateLastName();
        let isFirstNameValid = validateFirstName();
        let isEmailValid = validateEmail();
        let isPhoneNumberValid = validatePhoneNumber();

        return isLastNameValid && 
               isFirstNameValid && 
               isEmailValid && 
               isPhoneNumberValid
    };

    const clearFields = () => {
        state.lastName = '';
        state.firstName = '';
        state.id = '';
        state.email = '';
        state.phoneNumber = '';
        state.address = '';
        state.city = '';
        state.state = '';
        state.zipCode = '';
        state.country = '';
        state.serviceProvider = undefined;
    };

    // Initialize validation
    const initializeValidation = () => {
        // Only validate fields that have values
        if (state.lastName) validateLastName();
        if (state.firstName) validateFirstName();
        if (state.email) validateEmail();
        if (state.phoneNumber) validatePhoneNumber();
    };

    // Call initialization after a short delay to ensure DOM is ready
    setTimeout(initializeValidation, 100);

    return {
        state,
        validations,
        isValid,
        clearFields,
        initializeValidation
    };
}
